import { useEffect } from 'react';
import { getEnvironmentConfiguration } from '../../app/environments/environment-configuration';

const SmartLook = () => {
    const environmentConfiguration = getEnvironmentConfiguration();

    useEffect(() => {
        if (environmentConfiguration.SmartLookKey) {
            const script = document.createElement("script");
            script.text = `
  window.smartlook||(function(d) {
    var o=smartlook=function(){ o.api.push(arguments)},h=d.getElementsByTagName('head')[0];
    var c=d.createElement('script');o.api=new Array();c.async=true;c.type='text/javascript';
    c.charset='utf-8';c.src='https://rec.smartlook.com/recorder.js';h.appendChild(c);
    })(document);
    smartlook('init', '${environmentConfiguration.SmartLookKey}');`;

            document.body.appendChild(script);
        }
    },[]);

    return null;
};

export default SmartLook;
